import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';

import { firebaseError } from 'utils';
import { checkUserData } from './auth';
import { fetchCollection, fetchDocument, createDocument } from '../api';

const ENTITIES = 'LOGS';
const ENTITY = 'LOG';
const ENTITIES_COLLECTION = 'logs';
const Entity = 'Log';

export const ACTIONS_NAMES_DICT = {
  FETCH_DATA_INIT: `${ENTITIES}_FETCH_DATA_INIT`,
  FETCH_DATA_SUCCESS: `${ENTITIES}_FETCH_DATA_SUCCESS`,
  FETCH_DATA_FAIL: `${ENTITIES}_FETCH_DATA_FAIL`,
  CREATE_ENTITY_INIT: `${ENTITIES}_CREATE_${ENTITY}_INIT`,
  CREATE_ENTITY_SUCCESS: `${ENTITIES}_CREATE_${ENTITY}_SUCCESS`,
  CREATE_ENTITY_FAIL: `${ENTITIES}_CREATE_${ENTITY}_FAIL`,

  CLEAN_UP: `${ENTITIES}_CLEAN_UP`,
  CLEAR_DATA_LOGOUT: `${ENTITIES}_CLEAR_DATA_LOGOUT`,
};

const ACTIONS_DICT = Object.keys(ACTIONS_NAMES_DICT).reduce(
  (accumulator, currentKey) => {
    const currentValue = ACTIONS_NAMES_DICT[currentKey];
    accumulator[currentKey] = createAction(currentValue);
    return accumulator;
  },
  {}
);

export const LOGS_ACTIONS = Object.keys(ACTIONS_NAMES_DICT).reduce(
  (accumulator, currentKey) => {
    const key = ACTIONS_NAMES_DICT[currentKey];
    const value = ACTIONS_DICT[currentKey];
    accumulator[key] = value;
    return accumulator;
  },
  {}
);

export const fetchEntities = (entityId = '') => {
  return async (dispatch, getState) => {
    dispatch(checkUserData());

    dispatch(ACTIONS_DICT.FETCH_DATA_INIT());

    if (entityId) {
      let entity;
      try {
        entity = await fetchDocument(ENTITIES_COLLECTION, entityId);
      } catch (error) {
        toastr.error('', error);
        return dispatch(ACTIONS_DICT.FETCH_DATA_FAIL({ error }));
      }

      if (!entity) {
        const errorMessage = 'Entity not available';
        toastr.error('', errorMessage);
        return dispatch(ACTIONS_DICT.FETCH_DATA_FAIL({ error: errorMessage }));
      }

      const entities = getState()[ENTITIES_COLLECTION].data;
      entities.push(entity);

      return dispatch(
        ACTIONS_DICT.FETCH_DATA_SUCCESS({
          data: entities,
        })
      );
    }

    let entities;

    try {
      entities = await fetchCollection(ENTITIES_COLLECTION);
    } catch (error) {
      toastr.error('', error);
      return dispatch(ACTIONS_DICT.FETCH_DATA_FAIL({ error }));
    }

    return dispatch(
      ACTIONS_DICT.FETCH_DATA_SUCCESS({
        data: entities,
      })
    );
  };
};

export const clearEntitiesDataLogout = () => {
  return (dispatch) => {
    dispatch(ACTIONS_DICT.CLEAR_DATA_LOGOUT());
  };
};

export const createEntity = (entityData, options = { showToaster: true }) => {
  return async (dispatch, getState) => {
    dispatch(ACTIONS_DICT.CREATE_ENTITY_INIT());
    const { locale } = getState().preferences;

    // let response;

    const createEntityDbTask = createDocument(
      ENTITIES_COLLECTION,
      null,
      // uid,
      entityData
    );

    try {
      await Promise.all([createEntityDbTask]);
    } catch (error) {
      const errorMessage = firebaseError(error.code, locale);
      toastr.error('Failed to create log.', errorMessage);
      return dispatch(
        ACTIONS_DICT.CREATE_ENTITY_FAIL({
          error: errorMessage,
        })
      );
    }

    if (options && options.showToaster) {
      toastr.success('', `${Entity} created successfully`);
    }
    return dispatch(ACTIONS_DICT.CREATE_ENTITY_SUCCESS({ entity: entityData }));
  };
};

export const entitiesCleanUp = () => (dispatch) =>
  dispatch(ACTIONS_DICT.CLEAN_UP());
